module.exports = __webpack_public_path__ + "img/go-build-logo.29ec30ce.jpg";